import { render, staticRenderFns } from "./OverTimePlanDetails.vue?vue&type=template&id=57fcd37d&"
import script from "./OverTimePlanDetails.vue?vue&type=script&lang=js&"
export * from "./OverTimePlanDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports